import React, { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import ApiClient from "../ApiClient";
import { useNavigate } from "react-router-dom";
import NFDCimg from "../../../assets/images/NFDC-Logo.png";
import logo from "../../../assets/images/IFFFI_LOGO.png";
import Asimg from "../../../assets/images/GOLDEN_LOGO.svg";
import MenuRoundedIcon from "@mui/icons-material/MenuRounded";
import { postRequest } from "../../../API/IP";
import useMediaQuery from "@mui/material/useMediaQuery";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import PhoneAndroidIcon from "@mui/icons-material/PhoneAndroid";
// import { isTimeUp } from "../../Helper";

const NavBar = ({ activeTab, onMenuToggle }) => {
  const { getRequest } = ApiClient();
  const navigate = useNavigate();
  const isSmallScreen = useMediaQuery("(max-width: 900px)");

  const [userData, setUserdata] = useState([]);
  const [showAddNewEntry, setShowAddNewEntry] = useState(false);
  const [showAddNewEntryOtt, setShowAddNewEntryOtt] = useState(true);
  const [showAddNewEntryCmot, setShowAddNewEntryCmot] = useState(false);
  const [showAddNewEntryCinema, setShowAddNewEntryCinema] = useState(false);
  const [showAddNewEntrydd, setShowAddNewEntrydd] = useState(true);

  // const getEntryLimit = (typeId) => (typeId === 3 ? 10 : 5);

  const [impoData, setImpoData] = useState([]);
  let baseUrl = process.env.REACT_APP_BASE_PREFIX;
  useEffect(() => {
    const ImportantData = async () => {
      if (!baseUrl) {
        return;
      }
      try {
        const response = await fetch(`${baseUrl}/AppData.json`);
        const commonData = await response.json();
        setImpoData(commonData);
      } catch (error) {
        console.error(error, "importent adta error");
      }
    };

    ImportantData();
  }, []);

  const [iptimeUp, setIpTimeUp] = useState(false);
  const [otttimeUP, setOttTimeUp] = useState(false);
  const [cmotTimeUP, setCmotTimeUp] = useState(false);
  const [DDtimeUP, setDdTimeUp] = useState(false);
  const [CinematimeUP, setCinemaTimeUp] = useState(false);

  const isTimeUp = (dateTime) => {
    const now = new Date();
    const target = new Date(dateTime);
    return now > target;
  };

  const cleanDateString = (date, time) => {
    if (!date || !time) return null;
    const cleanedDate = date.replace(/(\d+)(st|nd|rd|th)/, "$1");
    return `${cleanedDate} ${time}`;
  };

  useEffect(() => {
    if (impoData?.indian_Peronoma) {
      const ipDate = cleanDateString(
        impoData.indian_Peronoma.last_date,
        impoData.indian_Peronoma.last_time
      );
      setIpTimeUp(isTimeUp(ipDate));
    }
    if (impoData?.ott) {
      const ottDate = cleanDateString(
        impoData.ott.last_date,
        impoData.ott.last_time
      );
      setOttTimeUp(isTimeUp(ottDate));
    }
    if (impoData?.cmot) {
      const cmotDate = cleanDateString(
        impoData.cmot.last_date,
        impoData.cmot.last_time
      );
      setCmotTimeUp(isTimeUp(cmotDate));
    }
    if (impoData?.cinema) {
      const CinemaDate = cleanDateString(
        impoData.cinema.last_date,
        impoData.cinema.last_time
      );
      setCinemaTimeUp(isTimeUp(CinemaDate));
    }
    if (impoData?.dd) {
      const ddDate = cleanDateString(
        impoData.dd.last_date,
        impoData.dd.last_time
      );
      setDdTimeUp(isTimeUp(ddDate));
    }
  }, [impoData]);

  // useEffect(() => {
  //   fetchData();
  //   UserData();
  // }, [activeTab]);

  useEffect(() => {
    const init = async () => {
      const userData = await UserData(); // get userdata from API
      fetchData(userData.type_id); // pass type_id directly
    };
    init();
  }, [activeTab]);

  const fetchData = async () => {
    try {
      if (activeTab === 0) {
        const preData = await getRequest("list");
        const data = preData.data || [];

        const user = userData?.type_id ? userData : await UserData();
        const userType = user?.type_id;

        let filteredEntries;

        if (userType === 3) {
          // For type_id 3, count all entries
          filteredEntries = data;
        } else {
          // For others, filter by category
          filteredEntries = Array.isArray(data)
            ? data.filter(
              (entry) => Number(entry.category) === Number(userType)
            )
            : [];
        }

        const limit = userType === 3 ? 10 : 5;
        setShowAddNewEntry(filteredEntries.length < limit);
      }

      if (activeTab === 1) {
        const preData = await getRequest("ott");
        const data = preData.data;
        if (data && data.length < 1) {
          setShowAddNewEntryOtt(true);
        } else {
          //setShowAddNewEntryOtt(false);
        }
      }
      if (activeTab === 2) {
        const preData = await getRequest("cmot");
        const data = preData.data;
        if (data && data.length < 1) {
          setShowAddNewEntryCmot(true);
        } else {
          setShowAddNewEntryCmot(false);
        }
      }
      if (activeTab === 3) {
        // const preData = await getRequest("cinema");
        const preData = await getRequest("cmot");
        const data = preData.data;
        if (data && data.length < 5) {
          setShowAddNewEntryCinema(true);
        } else {
          setShowAddNewEntryCinema(false);
        }
      }

      // if (activeTab === 3) {
      //   const preData = await getRequest("dd");
      //   const data = preData.data;
      //   if (data && data.length < 5) setShowAddNewEntrydd(true);
      // }
    } catch (error) {
      console.error("Fetch error:", error);
    }
  };

  // const UserData = async () => {
  //   try {
  //     const userData = await postRequest("get_login_user");
  //     const DataUser = userData.data;
  //     setUserdata(DataUser);
  //   } catch (error) {
  //     console.error("Fetch error:", error);
  //   }
  // };

  const UserData = async () => {
    try {
      const res = await postRequest("get_login_user");
      const DataUser = res.data;
      setUserdata(DataUser);
      return DataUser; // so we can use it immediately
    } catch (error) {
      console.error("Fetch error:", error);
      return {};
    }
  };

  const addNewEntry = () => {
    if (showAddNewEntry) {
      navigate("/ip");
    } else {
      alert("You have reached the maximum limit.");
    }
  };

  const addNewEntryOtt = () => {
    if (showAddNewEntryOtt) {
      navigate("/ott");
    } else {
      alert("You have reached the maximum limit.");
    }
  };
  const addNewEntryCmot = () => {
    if (showAddNewEntryCmot) {
      navigate("/cmot");
    } else {
      alert("You have reached the maximum limit.");
    }
  };

  const addNewEntryCinema = () => {
    if (showAddNewEntryCinema) {
      navigate("/cinemai-hackathon");
    } else {
      alert("You have reached the maximum limit.");
    }
  };
  // const addNewEntrydd = () => {
  //   if (showAddNewEntrydd) {
  //     navigate("/dd");
  //   } else {
  //     alert("You have reached the maximum limit.");
  //   }
  // };

  return (
    <div className="left_first_header">
      <div className="firstHead">
        {isSmallScreen && (
          <div className="burger">
            <Button onClick={onMenuToggle}>
              <MenuRoundedIcon />
            </Button>
          </div>
        )}

        {activeTab === 0 && (
          <>
            <div className="headimg logo-left" href="#home">
              <img
                src={logo}
                className="logo"
                width="140px"
                height="100"
                alt="NFDC Cinemas of India"
              />
            </div>
            <div className="headimg logo-center">
              <img
                src={Asimg}
                width="100%"
                className="logo"
                height="100%"
                alt="NFDC Cinemas of India"
              />
            </div>
            <div className="headimg logo-right">
              <img
                src={NFDCimg}
                className="logo"
                width="130px"
                height="100px"
                alt="NFDC Cinemas of India"
              />
            </div>
          </>
        )}
        {activeTab === 1 && (
          <>
            <div className="headimg logo-right" href="#home">
              <img
                src={logo}
                className="logo"
                width="140px"
                height="100"
                alt="NFDC Cinemas of India"
              />
            </div>
            <div className="imglogo">
              <img
                src={Asimg}
                width="100%"
                height="100%"
                className="d-flex justify-content-start logo"
                alt="NFDC Cinemas of India"
              />
            </div>
          </>
        )}
        {activeTab === 2 && (
          <>
            <div className="headimg logo-left" href="#home">
              <img
                src={logo}
                className="logo"
                width="140px"
                height="100"
                alt="NFDC Cinemas of India"
              />
            </div>
            <div className="headimg logo-center">
              <img
                src={Asimg}
                width="100%"
                className="logo"
                height="100%"
                alt="NFDC Cinemas of India"
              />
            </div>
            <div className="headimg logo-right">
              <img
                src={NFDCimg}
                className="logo"
                width="130"
                height="100"
                alt="NFDC Cinemas of India"
              />
            </div>
          </>
        )}
        {activeTab === 3 && (
          <>
            <div className="imglogo">
              <img
                src={Asimg}
                width="100%"
                height="100%"
                className="d-flex justify-content-start logo"
                alt="NFDC Cinemas of India"
              />
            </div>

            <div className="headimg logo-right" href="#home">
              <img
                src={logo}
                className="logo"
                width="140px"
                height="100"
                alt="NFDC Cinemas of India"
              />
            </div>
          </>
        )}
      </div>
      <hr className="m-0" />

      <div className="sec_head">
        {activeTab === 0 && (
          <div>
            <h6>Hello {userData.name}</h6>
            <p>
              <MailOutlineIcon sx={{ color: "red" }} /> {userData.email}
              <PhoneAndroidIcon sx={{ color: "black" }} /> +91-
              {userData.mobile}
            </p>
          </div>
        )}
        {activeTab === 1 && (
          <div>
            <h6>Hello {userData.name}</h6>
            <p>
              <MailOutlineIcon sx={{ color: "red" }} /> {userData.email}
              <PhoneAndroidIcon sx={{ color: "black" }} /> +91-
              {userData.mobile}
            </p>
          </div>
        )}
        {activeTab === 2 && (
          <div>
            <h6>Hello {userData.name}</h6>
            <p>
              <MailOutlineIcon sx={{ color: "red" }} /> {userData.email}
              <PhoneAndroidIcon sx={{ color: "black" }} /> +91-
              {userData.mobile}
            </p>
          </div>
        )}
        {activeTab === 3 && (
          <div>
            <h6>Hello {userData.name}</h6>
            <p>
              <MailOutlineIcon sx={{ color: "red" }} /> {userData.email}
              <PhoneAndroidIcon sx={{ color: "black" }} /> +91-
              {userData.mobile}
            </p>
          </div>
        )}

        {/* Add more Button for different active tab */}
        <div>
          {activeTab === 0 &&
            !iptimeUp &&
            (showAddNewEntry ? (
              <Button
                variant="contained"
                onClick={addNewEntry}
                style={{ backgroundColor: "#1c5768", color: "#fff" }}
              >
                Add New Entry
              </Button>
            ) : (
              ""
            ))}

          {activeTab === 1 &&
            !otttimeUP &&
            (showAddNewEntryOtt ? (
              <Button
                variant="contained"
                onClick={addNewEntryOtt}
                style={{ backgroundColor: "#1c5768", color: "#fff" }}
              >
                Add New Entry
              </Button>
            ) : (
              ""
            ))}
          {activeTab === 2 &&
            !cmotTimeUP &&
            (showAddNewEntryCmot ? (
              <Button
                variant="contained"
                onClick={addNewEntryCmot}
                style={{ backgroundColor: "#1c5768", color: "#fff" }}
              >
                Add New Entry
              </Button>
            ) : (
              ""
            ))}

          {/* {activeTab == 3 && (
            <Button
              variant="contained"
              onClick={addNewEntryCinema}
              style={{ backgroundColor: "#1c5768", color: "#fff" }}
            >
              Add New Entry
            </Button>
          )} */}
        </div>
      </div>
      <div>{/* Additional content can be added here */}</div>
    </div>
  );
};

export default NavBar;
